// import Errors from '@/shared/error/errors';
// import { routerAsync } from '@/app-module';
// import Message from '@/shared/message/message';
// import { i18n } from '@/i18n';
// import { IamService } from '@/modules/iam/iam-service';
// import { CompanyProfileService } from '@/modules/company-profile/company-profile-service';
import { getLanguageCode } from '@/i18n';

export default {
  namespaced: true,

  state: {
    currentLanguageCode: getLanguageCode(),
    imageLoaded: 0,
    imagesToPreload: [
      //#region [ this Images is loaded in english & arabic lang only ]
        'images/landingHead.png',
        'images/landingLogo.svg',
        '/images/halfFlag.png',
        '/images/moccupPhone.svg',
      //#endregion
        
      //#region [ this Images is loaded in english lang only ]
        '/images/slideItemOne.png',
        '/images/slideItemTwo.png',
        '/images/slideItemThree.png',
        '/images/slideItemFour.png',
        '/images/phones.png',
        'images/mobileHead.png',
        '/images/tourAppStore.png',
        '/images/tourIphone.png',
        '/images/appTour.png',
        '/images/clientAppStore.png',
      //#endregion

      //#region [ this Images is loaded in arabic lang only ]
        '/images/slideItemOneAr.png',
        '/images/slideItemTwoAr.png',
        '/images/slideItemThreeAr.png',
        '/images/slideItemFourAr.png',
        'images/phoneArabicUp.png',
        '/images/mobileArabicRTL.png',
        '/images/tourAppStoreAr.png',
        '/images/tourIphoneAr.png',
        '/images/appTourAr.png',
        '/images/clientAppStoreAr.png',
      //#endregion

      // '/images/sarOpaciBg.svg',
      // '/images/footerBg.jpg',
      // '/images/bgSaryahApp.png',
    ],
  },

  getters: {
    isImagesLoaded: (state) => state.imageLoaded == (state.imagesToPreload.length - 10 ),
    imageLoaded: (state) => state.imageLoaded,
    imagesToPreload: (state) => state.imagesToPreload,
    currentLanguageCode: (state) => state.currentLanguageCode,
  },

  mutations: {
    RESET(state) {
      state.imageLoaded = 0;
      state.isImagesLoaded = false;
    },
    CONFIRM_IMAGE_LOADED(state) {
      state.imageLoaded += 1;
    },
    SET_CURRENT_LANGUAGE_CODE(state, payload) {
      state.currentLanguageCode = payload
    },
  },

  actions: {
    onImgLoad({ commit }) {
      commit('CONFIRM_IMAGE_LOADED');
      // console.log(`Number Of Loading Image is Done: [ ${getters.imageLoaded} ]`)
    },
    changeCurrentLanguageCode({ commit }, language) {
      commit('SET_CURRENT_LANGUAGE_CODE', language)
    },
  },
};
